export default __webpack_public_path__ + "static/media/pattern-curve.05698a95.svg";